import { render, staticRenderFns } from "./PendingRulesView.vue?vue&type=template&id=15979000&scoped=true"
import script from "./PendingRulesView.vue?vue&type=script&lang=js"
export * from "./PendingRulesView.vue?vue&type=script&lang=js"
import style0 from "./PendingRulesView.vue?vue&type=style&index=0&id=15979000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15979000",
  null
  
)

export default component.exports